module.exports = __webpack_public_path__ + "static/media/Line 2.8d6d8e47.png";